import { Box, Button, Center, HStack, Stack, Text } from '@chakra-ui/core';
import React from 'react';
import { TFunction, useTranslation } from 'react-i18next';
import { HiOutlineDeviceMobile, HiMenuAlt4 } from 'react-icons/hi';
import { QuestionnaireListView } from './ListViewPreview';
import { MobilePreview } from './MobilePreview';

const previewModes = (t: TFunction<'questionnaireTemplate'>) =>
  ({
    device: { icon: <HiOutlineDeviceMobile />, label: t('formBuilder.preview.deviceViewButton') },
    list: { icon: <HiMenuAlt4 />, label: t('formBuilder.preview.listViewButton') },
  } as const);
type PreviewModeKey = keyof ReturnType<typeof previewModes>;

export const PreviewSidebar = React.memo(() => {
  const { t } = useTranslation('questionnaireTemplate');
  const [previewMode, setPreviewMode] = React.useState<PreviewModeKey>('device');

  return (
    <Box minHeight={0} p={6} height="100%" pr={0}>
      <Stack minHeight={0} height="100%">
        <HStack justify="space-between" pr={6}>
          <Text fontSize="lg" fontWeight="bold">
            {t('formBuilder.preview.title')}
          </Text>
          <HStack justify="flex-end">
            <Button
              size="sm"
              colorScheme="gray"
              onClick={() => setPreviewMode((prev) => (prev === 'device' ? 'list' : 'device'))}
            >
              {previewModes(t)[previewMode === 'device' ? 'list' : 'device'].label}
            </Button>
          </HStack>
        </HStack>

        {previewMode === 'list' && <QuestionnaireListView />}
        {previewMode === 'device' && (
          <Center flexGrow={1}>
            <MobilePreview />
          </Center>
        )}
      </Stack>
    </Box>
  );
});

PreviewSidebar.displayName = 'PreviewSidebar';
